(() => {
  const occasions = ['Everyday Wear', 'Work & Office', 'Date Night', 'Wedding & Bridal', 'Party & Night Out', 'Holidays & Celebrations', 'Vacation & Travel', 'Festivals & Concerts', 'Formal Events', 'Just for Fun'];
  const buildPost = draft => {
    const type = draft.type || 'POST';
    const categories = ['Prep & Lifting', 'Application', 'Curing', 'Nail Art', 'Extensions', 'Removal', 'Product Pairing', 'Nail Care', 'Tools'];
    if (!['POST', 'QUESTION'].includes(type)) throw new Error('Invalid content type.');
    const title = String(draft.title || '').trim();
    const content = String(draft.content || '').trim();
    if (!draft.userId) throw new Error('Please log in before posting.');
    if (!title || title.length > 200) throw new Error('Enter a title of 1–200 characters.');
    if (content.length > 20000) throw new Error('Content must be 20,000 characters or fewer.');
    if (type === 'POST' && !occasions.includes(draft.occasion)) throw new Error('Please select an occasion.');
    if (type === 'POST' && (!draft.nailShape || !draft.nailLength)) throw new Error('Select nail shape and nail length.');
    if (type === 'QUESTION' && !categories.includes(draft.category)) throw new Error('Select a valid collection.');
    if (type === 'POST' && !draft.media?.length) throw new Error('Add 1–9 photos or videos.');
    if ((draft.media || []).length > 9) throw new Error('Add no more than 9 photos or videos.');
    const media = (draft.media || []).map(item => {
      let valid = false;
      try { valid = ['http:', 'https:'].includes(new URL(item.url).protocol); } catch {}
      if (!valid || !['image', 'video'].includes(item.type)) throw new Error('Wait for all uploads to finish, or remove failed uploads.');
      return { type: item.type, url: item.url };
    });
    const products = (draft.products || []).map(product => {
      if (!product.productId) throw new Error('Please select the product again.');
      const result = { ...product, productId: String(product.productId) };
      if (result.productPrice !== undefined && result.productPrice !== '') {
        result.productPrice = Number(result.productPrice);
        if (!Number.isFinite(result.productPrice)) throw new Error('Invalid product price. Please select the product again.');
      } else delete result.productPrice;
      return result;
    });
    const fields = type === 'QUESTION' ? { category: draft.category } : { occasion: draft.occasion, nailShape: draft.nailShape, nailLength: draft.nailLength, ...(draft.skinTone ? { skinTone: draft.skinTone } : {}) };
    return { userId: String(draft.userId), email: String(draft.email || '').trim(), displayName: String(draft.displayName || '').trim(), type, title, content, ...fields, contentLicense: Boolean(draft.contentLicense), products, media };
  };
  const submitPost = async (draft, request = fetch) => {
    let payload = buildPost(draft);
    if (typeof window !== 'undefined' && window.CommunityFeedUtils) {
      const utils = window.CommunityFeedUtils;
      payload = utils.withUserIdentity(payload, await utils.resolveIdentity(payload));
    }
    const response = await request('https://informationcollection.benyuan1.com/api/community/content/submit', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: AbortSignal.timeout(30000)
    });
    const body = await response.json();
    if (!response.ok || body.status !== 'success') throw new Error(body.message || 'Unable to publish. Please try again.');
    if (!body.data?.id || body.data.published !== true) throw new Error(body.data?.message || 'Publication was not confirmed.');
    return body.data;
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { buildPost, submitPost };
  if (typeof window !== 'undefined') window.CommunityPostApi = { buildPost, submitPost };
})();
